import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Box, useTheme, useMediaQuery, Grid } from '@mui/material';
import clsx from 'clsx';
import BillingMovedBanner from 'components/BillingMovedBanner';
import FeatureAnnouncement from 'components/FeatureAnnouncement';
import SandboxBanner from 'components/SandboxBanner';
import Sidebar from 'components/V2/Sidebar';
import SidebarTour from 'components/V2/SidebarTour';
import useHubSpotChat from 'hooks/useHubSpotChat';
import PageBar from 'layouts/V2/Dashboard/components/PageBar';
import PropTypes from 'prop-types';
import endPoints from 'route/endpoints';
import PaymentInfoModal from 'views/AddPaymentMethodModal/PaymentInfoModal';

import { fetchAdminInformationAction } from 'redux/actions/auth';

import styles from './dashboard.module.css';

function Dashboard({
    children,
    adminData,
    mainContainerStyles,
    fetchAdminInformationAction,
    token,
}) {
    const location = useLocation();
    const theme = useTheme();

    const [openSidebar, setOpenSidebar] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

    useEffect(() => {
        if (!adminData) {
            fetchAdminInformationAction(token);
        }
    }, [fetchAdminInformationAction, adminData, token]);

    const handleToggler = () => {
        setOpenSidebar(!openSidebar);
    };

    const { openChatBot } = useHubSpotChat();

    const handleHelpClick = () => {
        openChatBot();
    };

    return (
        <>
            <Helmet>
                {!isMobile && (
                    <script
                        type="text/javascript"
                        id="hs-script-loader"
                        async
                        defer
                        src="//js-na1.hs-scripts.com/6431620.js"
                    ></script>
                )}
            </Helmet>
            <Box className={styles.dashboardContainer}>
                <Sidebar
                    isMobile={isMobile}
                    isTablet={isTablet}
                    openSidebar={openSidebar}
                    handleToggler={handleToggler}
                    handleHelpClick={handleHelpClick}
                />
                <Grid className={styles.dashboardInnerContent}>
                    <PageBar
                        isTablet={isTablet}
                        isMobile={isMobile}
                        handleToggler={handleToggler}
                    />
                    <SandboxBanner />
                    {location.pathname === endPoints.dashboard && <BillingMovedBanner />}
                    <Box className={clsx(mainContainerStyles, styles.renderScreenContainer)}>
                        <Box className={styles.innerScreenContainer}>{children}</Box>
                    </Box>
                </Grid>
            </Box>
            <PaymentInfoModal />
            <FeatureAnnouncement isMobile={isMobile} />
            <SidebarTour isSmallScreen={isTablet} />
        </>
    );
}

Dashboard.propTypes = {
    children: PropTypes.node,
    adminData: PropTypes.object,
    mainContainerStyles: PropTypes.string,
    token: PropTypes.string,
    fetchAdminInformationAction: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        adminData: state.auth?.adminData,
        token: state.auth?.userData.token,
    };
}

export default connect(mapStateToProps, { fetchAdminInformationAction })(Dashboard);
